var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParques2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Parques",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.906,
    height: 61.027,
    viewBox: "0 0 60.906 61.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006533;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M210.077,20.685A10.063,10.063,0,0,0,198.2,8.1a11.42,11.42,0,1,0-20.571,9.426,1.192,1.192,0,0,0,2.007-1.278A9.039,9.039,0,1,1,196.16,9.808a1.192,1.192,0,0,0,1.584.908,7.678,7.678,0,0,1,9.774,10.1,1.192,1.192,0,0,0,.607,1.532,9.067,9.067,0,0,1,5.291,8.224,9.79,9.79,0,0,1-.787,3.695,9.271,9.271,0,0,1-1.1,1.833,1.192,1.192,0,0,0,1.858,1.486,11.656,11.656,0,0,0,1.43-2.374,12.111,12.111,0,0,0,.977-4.64,11.454,11.454,0,0,0-5.715-9.89Z",
    transform: "translate(-154.886 0.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M319.744,148.547V132.884h1.1a1.192,1.192,0,1,0,0-2.384H314.9a11.038,11.038,0,0,0-7.857,3.254l-3.112,3.112V126.079l3.429-3.424a1.192,1.192,0,0,0-1.683-1.683l-1.746,1.743v-6.763a1.192,1.192,0,0,0-2.384,0v23.792a1.192,1.192,0,0,0,2.026.84l5.143-5.142a8.727,8.727,0,0,1,1.185-.992v14.106a3.569,3.569,0,0,0,.255,7.128h9.526a3.569,3.569,0,1,0,.06-7.137Zm-7.452-15.267a8.761,8.761,0,0,1,2.61-.4h2.462v15.662h-5.073Zm7.39,20.024h-9.515a1.192,1.192,0,1,1,0-2.384h9.517a1.192,1.192,0,0,1,0,2.384Z",
    transform: "translate(-265.609 -101.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M17.8,223.719a1.192,1.192,0,0,0-1.638.4l-.013.021a1.192,1.192,0,0,0,2.036,1.231l.013-.021A1.192,1.192,0,0,0,17.8,223.719Z",
    transform: "translate(-14.104 -196.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M45.663,159.723H38.328V146.255l4.08-4.08a1.192,1.192,0,1,0-1.683-1.682L36.3,144.921a1.192,1.192,0,0,0-.348.841v13.961H34.21V136.77a1.192,1.192,0,0,0-.525-.988l-3.527-2.372a9.487,9.487,0,0,0-.2-1.4h3.061a1.192,1.192,0,0,0,1.192-1.192V115.952a1.192,1.192,0,0,0-2.384,0v13.679H29.085a9.551,9.551,0,0,0-7.551-5.063,6.6,6.6,0,1,0-12.9-1.944,6.675,6.675,0,0,0,.092,1.1,9.893,9.893,0,0,0-2.659.9,1.192,1.192,0,0,0,1.073,2.125,7.52,7.52,0,0,1,3.163-.8,1.192,1.192,0,0,0,1.054-1.659,4.217,4.217,0,1,1,7.3.8,1.192,1.192,0,0,0,1.11,1.876,7.136,7.136,0,0,1,8.038,7.1h0a7.092,7.092,0,0,1-2.217,5.173,1.192,1.192,0,0,0-.155,1.54,5.941,5.941,0,1,1-9.72,6.833v-2.254l3.008-3.007,2.861,1.567a1.192,1.192,0,1,0,1.141-2.087l-2.255-1.234,1.157-1.157a1.192,1.192,0,0,0-1.682-1.683l-2.265,2.265h0l-1.965,1.967V131.654a1.192,1.192,0,0,0-2.384,0V136.2l-3.778-3.781A1.192,1.192,0,1,0,7.862,134.1l5.337,5.337a1.226,1.226,0,0,0,.128.108v5.316h0v2.217c-.007.012-.017.023-.023.035a5.827,5.827,0,1,1-8.878-7.26,1.192,1.192,0,0,0,.161-1.641,7.5,7.5,0,0,1-1.625-4.687,1.192,1.192,0,0,0-2.384,0,9.851,9.851,0,0,0,1.52,5.282,8.2,8.2,0,0,0,11.228,11.887v9.031H7.617a1.192,1.192,0,1,0,0,2.384H45.663a1.192,1.192,0,1,0,0-2.384Zm-13.837,0H15.705v-8.794a8.319,8.319,0,0,0,12.188-10.676,9.408,9.408,0,0,0,2.061-4.112l1.872,1.261Z",
    transform: "translate(-0.003 -101.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M220.07,37.225a6.987,6.987,0,0,0-6.98,6.979,1.192,1.192,0,0,0,2.384,0,4.6,4.6,0,0,1,4.6-4.6,1.192,1.192,0,1,0,0-2.384Z",
    transform: "translate(-187.692 -32.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M373.132,106.46a1.192,1.192,0,0,0,0,2.384,2.861,2.861,0,0,1,2.861,2.861,1.192,1.192,0,1,0,2.384,0A5.244,5.244,0,0,0,373.132,106.46Z",
    transform: "translate(-327.609 -93.77)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParques2);
export default __webpack_public_path__ + "static/media/Parques2.2c2530b85b16bbd1d04591f44cb959e0.svg";
export { ForwardRef as ReactComponent };